import { useContext, useState, useEffect } from "react";
import "./profileUpdatePage.scss";
import { AuthContext } from "../../context/AuthContext";
import apiRequest from "../../lib/apiRequest";
import { useNavigate } from "react-router-dom";
import UploadWidget from "../../components/uploadWidget/UploadWidget";

function ProfileUpdatePage() {
  const { currentUser, updateUser } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [avatar, setAvatar] = useState([]);
  const [oldAvatarPublicId, setOldAvatarPublicId] = useState(
    currentUser?.user?.avatar?.publicId || null
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (avatar.length > 0 && avatar[0].public_id) {
      setOldAvatarPublicId(currentUser?.user?.avatar?.publicId);
    }
  }, [avatar]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!currentUser?.user?.id) {
    setError("User data is not available!");
    return;
  }

  const formData = new FormData(e.target);
  const { username, email, password, phone } = Object.fromEntries(formData);

  const updateData = { username, email, phone };
  if (password) updateData.password = password;

const avatarData = avatar.length > 0
  ? { id: currentUser?.user?.id, url: avatar[0].url, publicId: avatar[0].public_id }
  : currentUser?.user?.avatar || null; 
  try {
    const res = await apiRequest.put(`/users/${currentUser.user.id}`, {
  ...updateData,
 ...(avatarData && { avatar: avatarData, avatarId: avatarData.publicId }),
});
   localStorage.setItem("user", JSON.stringify({
  user: { ...res.data, avatar: res.data.avatar }, // ✅ Обновляем `avatar`
  token: res.data.token || currentUser.token,
}));
    
    updateUser((prevUser) => ({
  user: { ...prevUser.user, ...res.data, avatar: res.data.avatar || avatarData || prevUser.user.avatar },
  token: res.data.token || prevUser.token,
}));

    navigate("/profile");
  } catch (err) {
    console.error("Profile update error:", err);
    setError(err.response?.data?.message || "An error occurred while updating profile!");
  }
};

  return (
    <div className="profileUpdatePage">
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <h1>Update Profile</h1>
          <div className="item">
            <label htmlFor="username">Username</label>
            <input id="username" name="username" type="text" defaultValue={currentUser?.user?.username} />
          </div>
          <div className="item">
            <label htmlFor="email">Email</label>
            <input id="email" name="email" type="email" defaultValue={currentUser?.user?.email} />
          </div>
          <div className="item">
            <label htmlFor="phone">Phone</label>
            <input id="phone" name="phone" type="text" defaultValue={currentUser?.user?.phone || ""} />
          </div>
          <div className="item">
            <label htmlFor="password">Password</label>
            <input id="password" name="password" type="password" />
          </div>
          <button type="submit">Update</button>
          {error && <span>{error}</span>}
        </form>
      </div>
      <div className="sideContainer">
        {!currentUser?.user ? (
          <p>Loading user data...</p>
        ) : (
          <>
            <img
              src={avatar.length > 0 ? avatar[0].url : currentUser?.user?.avatar?.url || "/noavatar.jpg"}
              alt="Avatar"
              className="avatar"
            />
            <UploadWidget
              uwConfig={{
                cloudName: "dge3e7ie3",
                uploadPreset: "foxads",
                multiple: false,
                sources: ["local", "url", "dropbox", "google_drive"],
                folder: "avatars",
                secure: true,
                sameSite: "None",
              }}
              setState={setAvatar}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default ProfileUpdatePage;
